<template>
  <div>
    <ViewTemplateConfiguration :templateList="templateList">
      <div slot="content-buttons">
        <Button _key="btnNatureOperationCreate" title="Natureza da Operação" classIcon="fas fa-plus-circle" type="primary"
          size="small" :clicked="create" />
      </div>
    </ViewTemplateConfiguration>
    <Modal title="Natureza da Operação" :width="600" :height="250" v-show="showModal('natureOperationCreateUpdate')">
      <NatureOperationCreateUpdate />
    </Modal>
  </div>
</template>

<script>


import ViewTemplateConfiguration from "@nixweb/nixloc-ui/src/component/template/ViewTemplateConfiguration";
import NatureOperationCreateUpdate from '../../../components/modules/tax-document/nature-operation/NatureOperationCreateUpdate.vue'

import Modal from "@nixweb/nixloc-ui/src/component/forms/Modal";
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";

import { mapGetters, mapMutations } from "vuex";

export default {
  name: "NatureOperationView",
  components: {
    ViewTemplateConfiguration,
    Button,
    Modal,
    NatureOperationCreateUpdate
  },
  data() {
    return {
      templateList: {
        urlGetApi: "/api/v1/tax-document/nature-operation/get-all",
        urlDeleteAllApi: "/api/v1/tax-document/nature-operation/delete",
        headerTable: [
          {
            field: "name",
            title: "Nome",
            type: "link",
            iconSearch: true,
            eventName: "natureOperationUpdate",
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters("generic", ["showModal", "event"]),
  },
  methods: {
    ...mapMutations("generic", ["addEvent", "openModal", "removeLoading"]),
    create() {
      this.openModal("natureOperationCreateUpdate");
      this.addEvent({ name: "natureOperationCreate" });
      this.removeLoading(["btnNatureOperationCreate"]);
    },
  },
  watch: {
    event: {
      handler(event) {
        if (event.name == "natureOperationUpdate")
          this.openModal("natureOperationCreateUpdate");
      },
      deep: true,
    },
  },
};
</script>
